import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { JourneyContext } from '../../../Contexts/JourneyContext'

import Popup from '../../App/Common/Popup/Popup';


const AnswersUnchecked = () => {
    let navigate = useNavigate();
    const { setCurrentPlace } = useContext(JourneyContext)
    useEffect(() => {
        setCurrentPlace({title: 'Ожидаем результатов проверки'})

    }, []);
    const onClick = () => {
        navigate(-1, { replace: true });

    }

    return (

        <Popup onClose={onClick} title={'Ответы еще на проверке'} onClickAction={onClick} buttonText={'Назад'} >
            <div className='lockedResource__body'>
                Ваши ответы еще на проверке у преподавателя. Дождитесь проверки открытых вопросов.
            </div>
        </Popup>
    )
}
export default AnswersUnchecked
